import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    some: [],
    all: [],
    coaches: [],
    enrollments: [],
    total: 0,
    pages: -1,
    loading: false,
    newUser: {},
    showNewUserForm: false,
    showSearchRealmUserForm: false,
    showShitchAddRealmForm: false,
    realms: null,
    waitingForRequest: false,
    isEditing: false,
    redirectToUsers: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_REDIRECT_TO_TABLE_USERS:
            return { ...state, redirectToUsers: payload };

        case actions.SOME_USERS_FETCHED:
            return { ...state, ...payload };

        case actions.EDIT_NEW_USER:
            return {
                ...state,
                newUser: { ...state.newUser, [payload.id]: payload.value },
            };

        case actions.IS_THIS_EDITING:
            return { ...state, isEditing: payload };

        case actions.SET_NEW_USER:
            return { ...state, newUser: payload };

        case actions.TOGGLE_SHOW_FORM:
            return { ...state, showNewUserForm: payload };

        case actions.TOGGLE_SHOW_FORM_SEARCH_REALMS:
            return { ...state, showSearchRealmUserForm: payload };

        case actions.TOGGLE_SHOW_SWITCH_ADD_REALMS:
            return { ...state, showShitchAddRealmForm: payload };

        case actions.CHECK_INFO_ABOUT_REALMS_USER:
            return { ...state, realms: payload };

        case actions.CLEAR_CHECK_INFO_ABOUT_REALMS_USER:
            return { ...state, realms: null };

        case actions.CLEAR_NEW_USER:
            return { ...state, newUser: {}, isEditing: false };

        case actions.TOGGLE_WAIT_FOR_REQUEST:
            return { ...state, waitingForRequest: payload };

        case actions.USER_DATA_FETCHED:
            return { ...state, ...payload };

        case actions.USERS_FETCH_LOADING:
            return { ...state, ...payload };

        case actions.USER_ENROLLMENTS_FETCHED:
            return { ...state, ...payload };

        case actions.ALL_USERS_FETCHED:
            return { ...state, ...payload };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/users/users.reducer.js